import { Brand } from "./Brand";
import { OrderCalendarMonth } from "./OrderCalendarMonth";
import { State } from "./State";
import { Territory } from "./Territory";
import { AsyncResource } from "./utilityTypes";

export type Channel = "retail" | "on_premise";
export const channelOptions: { id: Channel; name: string }[] = [
  { id: "retail", name: "Retail" },
  { id: "on_premise", name: "On Premise" },
];
export enum ProgramStatus {
  Draft = "draft",
  Queued = "queued",
  Submitted = "submitted",
  Canceled = "canceled",
  Error = "error",
}
export type ProgramOrderType = "pre-order" | "from-inventory" | "on-demand";

export enum AccessType {
  Internal = "internal",
  Distributor = "distributor",
  All = "all",
}

export const accessTypeLabels = {
  [AccessType.Internal]: "Internal",
  [AccessType.Distributor]: "Distributor",
  [AccessType.All]: "All",
};

export const accessTypeOptions = Object.entries(accessTypeLabels).map(
  ([id, label]) => ({ id, name: label })
);

export interface Program {
  id: string;
  accessType: AccessType;
  anaplanProgramCodes: string;
  brandAssignmentLevel: "program" | "item";
  brands: Brand[];
  /** Fiscal year (e.g. "FY26") chosen for a January in-market date. */
  budgetYearOverride?: null | string;
  businessUnitNames: string[];
  channel: Channel;
  clonedFromProgram: null | AsyncResource<"program">;
  cprSubmissionUrl: string;
  createdBy: null | string;
  description: null | string;
  endDate: string;
  externalId: string;
  externalWorkfrontEprId: null | string;
  externalWorkfrontId: null | string;
  goals: null | string;
  imgUrl: null | string;
  isBrandFunded: boolean;
  isStateExclusive: boolean;
  isTerritoryExclusive: boolean;
  itemCount: number;
  name: string;
  note: null | string;
  orderCalendarMonth: OrderCalendarMonth | null;
  orderCalendarMonths: OrderCalendarMonth[];
  orderType: ProgramOrderType;
  primaryBrand: Brand;
  type: string;
  programType: AsyncResource<"programType">;
  sendToContentHub: boolean | null | string;
  sponsorTerritory: null | string;
  /** The program's in-market start date. On programs of order-type "pre-order", this is derived from the program's OCM in-market-date */
  startDate: string;
  states: State[];
  status: ProgramStatus;
  strategies: null | string;
  territories: Territory[];
  workfrontUrl: null | string;
}
